import { useState, useEffect } from 'react';
import { apiService, SEOData } from '../services/api';

const useSEO = () => {
  const [seoData, setSeoData] = useState<SEOData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSEOData = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await apiService.getSEO();
        setSeoData(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch SEO data');
      } finally {
        setLoading(false);
      }
    };

    fetchSEOData();
  }, []);

  return { seoData, loading, error };
};

export default useSEO; 